import { Button } from '@mui/material';
import { Link } from '../../../components';
import { useQuery } from 'react-query';
import { IBuild, IResponse } from '../../../models';
import { downloadContract, getPersonBuilds } from '../../../fetch';
import { useContext, useMemo, useState } from 'react';
import { UserContext } from '../../../context';
import { useSnackbar } from 'notistack';

export const ContractButton = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useContext(UserContext);
  const [isDownloading, setDownloading] = useState(false);
  const personId = user?.externalUser?.personId;
  const { isLoading, data: builds } = useQuery<IResponse<IBuild[]>, Error>(
    ['contract-builds'],
    async () =>
      await getPersonBuilds(personId, {
        perPage: '2', // for our purposes, we need to know if multiple builds meet the criteria
        buildStatuses: ['ContractAccepted', 'TenDayComplete', 'Closing', 'Complete']
      }),
    {
      enabled: !!personId
    }
  );
  const hasMultipleBuilds = useMemo(() => builds?.records?.length > 1, [builds]);
  return personId ? (
    <Button
      variant="contained"
      sx={{
        width: { xs: '100%', md: '250px' }
      }}
      component={hasMultipleBuilds ? Link : undefined}
      to={hasMultipleBuilds ? '/my-build?homeownerPortal=true' : undefined}
      type="white"
      onClick={
        hasMultipleBuilds
          ? undefined
          : async () => {
              try {
                setDownloading(true);
                await downloadContract(builds?.records[0].buildId);
              } catch (error) {
                enqueueSnackbar('Failed to download contract', { variant: 'error' });
              } finally {
                setDownloading(false);
              }
            }
      }
      disabled={
        personId === undefined ||
        isLoading ||
        builds?.records?.length === 0 ||
        isDownloading ||
        (builds?.records?.length === 1 && !builds?.records[0].hasContractFile)
      }
    >
      Contract
    </Button>
  ) : null;
};
